import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose, withProps } from 'recompose';

import formControl from './formControl';
import styles from './styles.css';
import { stringToHourFormat } from '../../lib/dates';

function TimeInput({
  input: {
    value, onChange, onBlur, ...otherInputProps
  },
  disabled,
  bigText,
  className,
  type,
}) {
  return (
    <input
      {...otherInputProps}
      value={value}
      type={type}
      className={classNames('form-control', { [styles.bigInputText]: bigText }, className)}
      placeholder="--:--"
      onChange={onChange}
      onBlur={onBlur}
      onFocus={(event) => event.target.select()}
      disabled={disabled}
    />
  );
}

TimeInput.defaultProps = {
  disabled: false,
  bigText: false,
  className: undefined,
  type: 'text',
};

TimeInput.propTypes = {
  /* input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired, */
  disabled: PropTypes.bool,
  bigText: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
};

export default compose(
  formControl,
  withProps(({ input }) => ({
    input: {
      ...input,
      onChange: event => input.onChange(event.target.value),
      onBlur: event => input.onBlur(stringToHourFormat(event.target.value)),
    },
  })),
)(TimeInput);
